import { computed, ref, shallowRef } from '@vue/composition-api'
import { parseSportByName } from '@ms/stores/sports/map'
import { isLiveMatch, isPrematch } from './status'

const matchInfo = shallowRef({})
const paramSportId = ref('')

const sportId = computed(() => matchInfo.value.sportId || paramSportId.value)
const server = computed(() => matchInfo.value.server)

export const prefillMatchSummary = (data = {}) => {
  const temp = { ...data }
  delete temp.markets
  delete temp.marketInfo
  delete temp.outcomeInfo
  matchInfo.value = temp
}

// 解析 & 设置 route.params.sportId, 由于 url 可更改，这个值不靠谱，仅作为备选
export const setParamSportId = (sportName = 'sportName') => {
  const sport = parseSportByName(sportName)
  if (sport) {
    paramSportId.value = sport.sportId
  }
}

export const resetMatchInfo = () => {
  matchInfo.value = {}
}

export default function useMatchInfo() {
  return {
    matchInfo,
    sportId,
    server,
    isLive: computed(() => isLiveMatch(matchInfo.value.status)),
    isPrematch: computed(() => isPrematch(matchInfo.value.status))
  }
}
